export { initializeHostedInput, notifyInitializeError } from '../hosted-form/iframe-content';
